import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Intro from "../../../../../elements/blocks/intro";
import ChoiceFieldDetails from "../../../../../elements/campaigns/choice-fields/choice-field-details";
import Nope from "../../../../../elements/blocks/nope";
import { useApiTenant } from "../../../../../../api/api-tenant";
export default function ChoiceFieldView() {
    const { t } = useTranslation();
    const { id } = useParams();
    const api = useApiTenant();
    const [choiceField, setChoiceField] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        api.GET_campaignsChoiceField(id)
            .then(response => {
            setChoiceField(response.data.shared_choice);
            setIsLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error))
                console.error(error);
        });
        return () => api.cancel();
    }, []);
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: choiceField ? choiceField.name : t("fields.field") + " #" + id, breadcrumbs: [
                    {
                        name: t("settings"),
                        link: "/settings",
                    },
                    {
                        name: t("fields.fields"),
                        link: "/settings/fields",
                    },
                    {
                        name: t("fields.shared-fields.shared-fields"),
                        link: "/settings/fields/shared",
                    },
                    {
                        name: t("fields.shared-fields.choice-fields.choices"),
                        link: "/settings/fields/shared/choices",
                    },
                    {
                        name: choiceField ? choiceField.name : t("fields.field"),
                        link: "/settings/fields/shared/choices/" + id,
                    },
                ], button: choiceField
                    ? {
                        label: t("fields.shared-fields.choice-fields.edit-choice-field"),
                        link: "/settings/fields/shared/choices/" + id + "/edit",
                        color: "primary",
                        type: "edit",
                    }
                    : undefined, loading: isLoading }), isLoading ? (_jsx(Fragment, {})) : choiceField ? (_jsx(ChoiceFieldDetails, { choice: choiceField })) : (_jsx(Nope, { title: t("errors.404"), caption: t("fields.shared-fields.choice-fields.errors.not-found") }))] }));
}
